import {DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger} from '@/components/ui/dropdown-menu'
import {usePathname, useRouter} from '@/i18n/navigation'
import {routing} from '@/i18n/routing'
import {ChevronDown, Loader} from 'lucide-react'
import {useLocale} from 'next-intl'
import {useParams} from 'next/navigation'

import React, {useTransition} from 'react'

interface Props {
  darkMode?: boolean
}

export const LocaleSwitcher: React.FC<Props> = ({darkMode = false}) => {
  const locale = useLocale()
  const router = useRouter()
  const [isPending, startTransition] = useTransition()
  const pathname = usePathname()
  const params = useParams()

  function onSelectChange(nextLocale: string) {
    startTransition(() => {
      router.replace(
        // @ts-expect-error -- TypeScript will validate that only known `params`
        // are used in combination with a given `pathname`. Since the two will
        // always match for the current route, we can skip runtime checks.
        {pathname, params},
        {locale: nextLocale},
      )
    })
  }

  return (
    <DropdownMenu>
      {isPending ? (
        // Render a static, non-interactive spinner while loading
        <div className="flex items-center px-2 py-1">
          <Loader className={`h-4 w-4 animate-spin ${darkMode ? 'text-gray-300' : 'text-gray-900'}`} />
        </div>
      ) : (
        <DropdownMenuTrigger asChild>
          <button
            className={`flex items-center gap-1 font-semibold ${darkMode ? 'text-gray-300 hover:text-white data-[state=open]:text-white' : 'text-gray-900 hover:text-[#B50A7A] data-[state=open]:text-[#B50A7A]'}`}
          >
            {locale.toUpperCase()}
            <ChevronDown className="h-4 w-4" />
          </button>
        </DropdownMenuTrigger>
      )}

      <DropdownMenuContent className="rounded-lg shadow-lg px-4 py-2 space-y-1">
        {/* PT is accessible via direct URL but hidden from the selector until fully launched. Remove the filter to activate. */}
        {routing.locales
          .filter((item) => item !== 'pt')
          .map((item) => (
            <DropdownMenuItem key={item} asChild>
              <button onClick={() => onSelectChange(item)} className="font-medium text-sm hover:text-[#B50A7A] w-full">
                {item.toUpperCase()}
              </button>
            </DropdownMenuItem>
          ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
